/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Pending_DuplicatedInputs */

const vi_einvoice_pending_duplicated = /** @type {(inputs: Einvoice_Pending_DuplicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA báo đơn này đã có hóa đơn. Hãy nhập ký hiệu và số hóa đơn đó.`)
};

/**

* @param {Einvoice_Pending_DuplicatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_pending_duplicated = /** @type {((inputs?: Einvoice_Pending_DuplicatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Pending_DuplicatedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_pending_duplicated(inputs)
});